<template>
  <div id="app">
    <Header />
    <router-view/>

    <div class="block-sidebar">
      <div class="sidebar-item">
        <img src="@/assets/013.png" class="sidebar-btn" alt="sidebar-btn" />
        <div>电话咨询</div>
      </div>
      <div class="sidebar-item">
        <img src="@/assets/014.png" class="sidebar-btn" alt="sidebar-btn" />
        <div>微信咨询</div>
      </div>
      <div class="sidebar-item">
        <img src="@/assets/015.png" class="sidebar-btn" alt="sidebar-btn" />
        <div>立即体验</div>
      </div>


    </div>
    <footer>
      <div>
       
 
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #000;text-decoration: none;">  蜀ICP备2025129125号-2</a>
         
          </p>
          
 
      </div>
    </footer>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Header from './components/Header.vue'

export default {
  name: 'app',
  components: {
    HelloWorld,
    Header
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
}
.block-sidebar {
    box-shadow: 0px 0px 7px 0px rgb(0 0 0 / 18%);
    border-radius: 16px;
    position: fixed;
    right: 6px;
    top: 50%;

    z-index: 99;
    padding: 8px 12px;
    background-color: #fff;
}
.sidebar-btn{
  width: 30px;
  height: 30px;
}
.sidebar-item{
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
      padding: 10px 0;
}
.sidebar-item:last-child{
  border-bottom: none;
}
footer{
    background-color: #f6f6f6;
    padding: 16px 0;
}
footer p{
  margin: 0;
}
</style>
